// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalRemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/product_fiscal/remover
 */
import { registerContract } from './validate'

export interface So_ProductFiscalRemoverInput {
so_product_fiscal_id: number
}

registerContract('So_ProductFiscalRemoverInput', {
  so_product_fiscal_id: { type: 'number',  required: true },
})
